import {Navigate, useLocation, useOutlet} from "react-router-dom";
import {useTheme} from '@mui/material/styles';
import {useAuth} from "hooks/useAuth";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Sidebar from "../sidebar/Sidebar";
import Box from "@mui/material/Box";
import ScrollBar from "shared/ui/ScrollBar";
import useMediaQuery from "@mui/material/useMediaQuery";
import AppLogout from "./AppLogout";
import SidebarMini from "../sidebar/SidebarMini";
import CssBaseline from '@mui/material/CssBaseline';
import {useState} from "react";
import PusherNotifications from "../../features/notifications/components/PusherNotifications";

interface IProps {
    fullScreen?: boolean;
    allowedRoles: string[];
}

const LayoutProtected = ({fullScreen = false, allowedRoles}: IProps) => {
    const {user} = useAuth();
    const outlet = useOutlet();
    const location = useLocation();
    const theme = useTheme();
    const isLargeScreen = useMediaQuery(theme.breakpoints.up("lg"));
    const localStorageUser = window.localStorage.getItem("user");

    const [open, setOpen] = useState(true);

    const handleDrawerToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    if (user.client) {
        return <Navigate to="/not-found"/>;
    }

    if (!user || user.token === undefined || user.token === null || user.token === "" || localStorageUser === "{\"theme\":\"light\"}") {
        return <Navigate to="/"/>;
    }

    return allowedRoles.find((role) => user.position.includes(role)) ? (
        <AppLogout>
            <PusherNotifications/>
            {!fullScreen && !isLargeScreen && (
                <>
                    <Grid
                        container
                        direction="row"
                        justifyContent="flex-start"
                        spacing={0}
                        sx={{backgroundColor: {xs: "background.paper", lg: "transparent"}}}
                    >
                        <Grid
                            item
                            xs={12}
                            lg={3}
                            xl={3}
                            maxHeight="100dvh"
                            sx={{
                                paddingRight: {xs: 0, lg: "10px"},
                                backgroundColor: {xs: "transparent", lg: "extra.sidebar"},
                                height: {xs: "auto", lg: "100dvh"},
                            }}
                        >
                            <Sidebar/>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            lg={9}
                            xl={9}
                            sx={{
                                backgroundColor: "background.default",
                                borderRadius: {xs: 2, lg: 0},
                                height: {xs: "auto", lg: "100dvh"},
                                maxHeight: {xs: "auto", lg: "100dvh"},
                            }}
                        >
                            <Box display="flex" flexDirection="column" justifyContent="space-between"
                                 sx={(theme) => ({
                                     padding: {xs: theme.spacing(3, 0, 3, 0), md: theme.spacing(5, 1, 5, 1)},
                                     height: "auto",
                                     minHeight: "calc(100dvh - 149px)"
                                 })}>
                                <Container maxWidth="xl">{outlet}</Container>
                            </Box>
                        </Grid>
                    </Grid>
                </>
            )}
            {!fullScreen && isLargeScreen && (
                <Box sx={{ display: 'flex' }}>
                    <CssBaseline />
                   <SidebarMini open={open} handleDrawerToggle={handleDrawerToggle}/>
                    <Box component="main" sx={{flexGrow: 1, minWidth: 0, position: "relative"}}>
                        <Box sx={{ width: '100%'}}>
                        <ScrollBar style={{height: "100dvh", width: "100%"}} forceVisible="x" autoHide={false}>
                            <Box sx={(theme) => ({
                                padding: {
                                    lg: theme.spacing(5, 0, 5, 0),
                                    xl: theme.spacing(5, 1, 5, 1),
                                }
                            })}>
                                <Container maxWidth="xl">{outlet}</Container>
                            </Box>
                        </ScrollBar>
                        </Box>
                    </Box>
                </Box>
            )}
            {fullScreen && (
                outlet
            )}
        </AppLogout>
    ) : (
        <Navigate to="/" state={{from: location}} replace/>
    )
};

export default LayoutProtected;
